import React, { useState, useContext, useEffect } from 'react';
import ImageComponent from 'atoms/Image';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFullImagePath,
  getItemQuantity,
  getTernaryValue,
  getValueOrDefaultObject,
  isEmptyObject,
  isMobileDevice,
  displayBucketIcon,
  getEmptyObjectforNull,
  getPriceBasedOnShowPriceWithTaxFlag,
} from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import heartIcon_activeFavourite from 'styles/staticAssets/images/heartIcon_activeFavourite.svg';
import heart_favIcon_active_white from 'styles/staticAssets/images/heart_favIcon_active_white.svg';
import Non_veg_dot_Icon from 'styles/staticAssets/images/Non_veg_dot_Icon.svg';
import Veg_dot_Icon from 'styles/staticAssets/images/Veg_dot_Icon.svg';
import { MENU_PLP_CONSTANT } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import ORDER_HISTORY from '../Constants/Constants';
import { QuantityModifier } from 'molecules/QuantityModifier';
import { classesCardButton } from 'organisms/MenusPLP/Presentation/MenuCard';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
import { UserOrderContext } from 'context/context';
import {
  menuCardBtnTextForFavAndRecommendedMenu,
  shouldDisableButton,
} from 'organisms/MenusPLP/MenusPlpUtilities/MenusPlpUtils';
import { CustomizableItemModal } from 'organisms/CustomisationModal/index';
import { loggedIN } from 'common/constants/SharedConstants';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';

const classesCardButtonDiv = (itemCount, isLoggedIn) => {
  return itemCount ? 'cardwithQuantity ' + isLoggedIn : 'cardwithNoquantity';
};

const getImageIconForMsite = (isMobile, additionalProperties) => {
  return isMobile ? (
    <img
      className='menu-vegOrNonVeg-icon'
      alt=' '
      src={getTernaryValue(!additionalProperties?.veg, Non_veg_dot_Icon, Veg_dot_Icon)}
    ></img>
  ) : (( !additionalProperties?.veg && (
    translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.NON_VEG)
  )) || (
    translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.VEG)
  ));
};

const FavouriteMenuCard = props => {
  const {
    isProductAvailable,
    catalogueData,
    maxItemCountPerLineItem,
    product,
    customerId,
    differencePrice,
    currencySymbol,
    additionalProperties,
    addItemToUnFavouriteFunction,
    addToCartFunction,
    userParams,
    getPrice,
    storeClosedData
  } = props;

  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  const { MINI_PDP_DATA, FROMFLAGEDIT, EDIT_CLICKED } = START_ORDER_CONSTANTS;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { ITEM_UNAVAILABLE } = ORDER_HISTORY;
  const { ITEM_QUANTITY } = MENU_CONSTANT;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const [itemCount, setItemCount] = useState(0);
  const [itemFoodlineId, setItemFoodlineId] = useState(null);
  const [itemEntries, setItemEntries] = useState(0);
  const [itemUnitPrice, setItemUnitPrice] = useState(0);
  const [openCostomizedModal, setOpenCostomizedModal] = useState(false);
  const [filteredPreviousData, setFilteredPreviousData] = useState([]);
  const [foodId, setFoodId] = useState('');
  const { flatResponse: { productMapById = {} } = {} } = getEmptyObjectforNull(
    useSelector(({ menuReducer }) => menuReducer),
  );
  const [isEditSelectionFavMenu, setIsEditSelectionFavMenu] = useState(false);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const isLoggedIn = getTernaryValue(userParams.loggedIn, loggedIN, '');
  const dispatch = useDispatch();
  const { tenantReducer } = useSelector(data => {
    return data;
  });
  const { tenantId, currencyConversionFactor, componentOptions } = tenantReducer;
  const { web: { global: { showPriceWithTax = false } = {} } = {} } = componentOptions ?? {};

  const dataFilter = foodItemId => {
    if (cartData?.id) {
      let filteredData = cartData?.foodLines.filter(value => value?.item?.id === foodItemId);
      setFilteredPreviousData(filteredData);
    }
    setFoodId(foodItemId);
    setOpenCostomizedModal(true);
  };

  const editItemQuantity = () => {
    if (product.isCustomized) {
      dataFilter(catalogueData?.mdmId);
    }
  };

  const updateItemQuantity = (itemData, flag) => {
    const itemPrice = Number((itemUnitPrice / currencyConversionFactor).toFixed(2));

    let item = {
      foodName: catalogueData?.name,
      foodItemId: catalogueData?.mdmId,
      cartPrice: itemPrice,
      modifiers: [],
      quantity: itemCount,
      foodLineId: itemFoodlineId,
    };

    const { itemQuantityHandler } = FoodItemListHandlers(
      { cartId: cartData.id },
      tenantId,
      undefined,
      productMapById,
      userOrderStateDispatch,
      dispatch,
      undefined,
    );
    if (flag === QUANTITY_ACTION.Increase) {
      if (product.isCustomized) {
        dataFilter(item?.foodItemId);
      } else {
        itemQuantityHandler(item, QUANTITY_ACTION.Increase);
      }
    } else {
      if (itemEntries > 1) {
        dataFilter(item?.foodItemId);
      } else {
        itemQuantityHandler(item, QUANTITY_ACTION.Decrease);
      }
    }
  };

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    const getItem = isEmptyObject(cartData) ? getItemQuantity(product.id, cartData) : {};
    const getItemCount = getTernaryValue(isEmptyObject(getItem), getItem.count, 0);
    const getItemfoodLineId = getTernaryValue(isEmptyObject(getItem), getItem.matchedItemFoodLineId, '');
    const getItemEntries = getTernaryValue(isEmptyObject(getItem), getItem.entriesCount, 0);
    const getItemUnitPrice = getTernaryValue(isEmptyObject(getItem), getItem.itemUnitPrice, '');
    setItemCount(getItemCount);
    setItemFoodlineId(getItemfoodLineId);
    setItemEntries(getItemEntries);
    setItemUnitPrice(getItemUnitPrice);
  }, [cartData, product.id]);

  /*
   * RENDEV-14165 adding veg and non-veg icon for m-site in vegNonvegCheck
   */

  const vegNonvegCheck = additionalPropertiesVal => {
    return (
      <div className='medium-menu-vegOrNonVeg'>
        {getImageIconForMsite(isMobile, additionalPropertiesVal)}
        {additionalPropertiesVal?.servings && <div className='Dot'></div>}
        {MENU_PLP_CONSTANT.MENU_CARD.SERVES}
        {additionalPropertiesVal?.servings}
      </div>
    );
  };

  const priceDisplay = (isProductAvailableVal, catalogue_data) => {
    const currentPrice = getPriceBasedOnShowPriceWithTaxFlag(
      catalogue_data?.availability[0],
      catalogue_data?.additionalPropertyMap?.pricewithouttax,
      currencyConversionFactor,
      showPriceWithTax,
    );
    return (
      <div className='medium-menu-product-price'>
        {isProductAvailableVal ? (
          <span className='price-difference-container'>
            {getTernaryValue(
              differencePrice !== 0,
              (
                <span className='prev-price'>
                  {currencySymbol}
                  {product.price}
                </span>
              ) -
                (
                  <span className='new-current-price'>
                    {currencySymbol}
                    {currentPrice}
                  </span>
                ),
              <span className='current-price'>
                {currencySymbol}
                {currentPrice}
              </span>,
            )}
          </span>
        ) : (
          ''
        )}
      </div>
    );
  };
  const renderQuantityModifier = (itemCountVal, updateItemQuantityVal, maxItemCountPerLineItemVal) => {
    return (
      <QuantityModifier
        itemCount={itemCountVal}
        itemQuantity={ITEM_QUANTITY}
        updateItemQuantity={updateItemQuantityVal}
        quantityAction={QUANTITY_ACTION}
        item={undefined}
        maxItemCountPerLineItem={maxItemCountPerLineItemVal}
        cartItemCount={1}
      />
    );
  };

  const renderItemUnavailableCartBtn = () => {
    return (
      <div className='cart-btn-container'>
        <div className='cardButtonOnly'>
          <button
            disabled
            className='button activeBtn redButton medium-menu-cart-button medium-menu-cart-button-disabled'
            aria-label='Add to Cart'
            tabindex='0'
            data-testid='add-to-cart-L-402983'
          >
            {translateWithI18Next(ITEM_UNAVAILABLE)}
          </button>
        </div>
      </div>
    );
  };

  const editSelectionsHandlerFavMenu = () => {
    if (itemCount === 1) {
      userOrderStateDispatch({
        type: MINI_PDP_DATA,
        value: { id: catalogueData?.mdmId, flag: FROMFLAGEDIT, foodLineId: itemFoodlineId },
      });
      userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
      userOrderStateDispatch({
        type: EDIT_CLICKED,
        value: { cartEditClicked: false },
      });
      dispatch(
        fetchItemDetailsAction({
          tenantId: tenantId,
          catalogName: cartData?.catalog,
          itemId: catalogueData?.mdmId,
        }),
      );
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: product.id.split('-')[0],
        }),
      );
    } else {
      editItemQuantity();
      setIsEditSelectionFavMenu(true);
      setOpenCostomizedModal(true);
    }
  };

  return (
    <React.Fragment>
      <div
        className={
          isProductAvailable
            ? 'medium-menu-container medium-menu-container-fav-menu'
            : 'medium-menu-container medium-menu-container-fav-menu medium-menu-container-fav-menu-disabled'
        }
      >
        <div className='product-container'>
          <div className='medium-menu-product-card product-card-active' data-testid=''>
            {isProductAvailable ? (
              <ImageComponent
                className='medium-menu-product-image medium-menu-product-image-fav'
                srcFile={getFullImagePath(catalogueData?.imageName, tenantReducer)}
                alt={'No-Image'}
                defaultPath={getFullImagePath(null, tenantReducer, true)}
              />
            ) : (
              <ImageComponent
                className='medium-menu-product-image medium-menu-product-image-fav'
                srcFile={getFullImagePath(product.imageName, tenantReducer)}
                alt={'No-Image'}
                defaultPath={getFullImagePath(null, tenantReducer, true)}
              />
            )}
            <div className='discount-product-ribbon'></div>
            <span className='discount-ribbon-text'></span>
            <img
              src={heart_favIcon_active_white}
              alt={'favourite menu product'}
              className='menu-product-save'
              data-testid='on-image-fav'
              onClick={() => addItemToUnFavouriteFunction(tenantId, customerId, product.id)}
            />
            <div className='menu-card-content menu-card-content-fav' data-testid='menu-card-content-pdp-nav'>
              <div className='medium-menu-product-header'>
                {getTernaryValue(isProductAvailable, catalogueData?.name, product.name)}
              </div>
              {!isMobile ? (
                <>
                  <img
                    className='menu-vegOrNonVeg-icon'
                    src={(!additionalProperties?.veg && Non_veg_dot_Icon) || Veg_dot_Icon}
                    alt={'favourite menu product-vegOrNonVeg-icon'}
                  />
                  {vegNonvegCheck(additionalProperties)}
                  {priceDisplay(isProductAvailable, catalogueData)}
                  <div className='medium-menu-product-description' id='longDescription'>
                    {getTernaryValue(
                      isProductAvailable,
                      catalogueData?.longDescription[0]?.value,
                      product.description[0]?.value,
                    )}
                  </div>
                </>
              ) : (
                <div className='product-details-mobile-view'>
                  <div className='medium-menu-product-description' id='longDescription'>
                    {getTernaryValue(
                      isProductAvailable,
                      catalogueData?.longDescription[0]?.value,
                      product.description[0]?.value,
                    )}{' '}
                  </div>
                  <div className='price-veg-nonveg'>
                    {priceDisplay(isProductAvailable, catalogueData)}
                    {vegNonvegCheck(additionalProperties)}
                    <div className='heart-icon'>
                      {(( isProductAvailable && (
                        <img
                          src={heartIcon_activeFavourite}
                          alt={'favourite menu product'}
                          className='mobile-fav-menu-style'
                          data-testid='mobile-view-fav'
                          onClick={() => addItemToUnFavouriteFunction(tenantId, customerId, product.id)}
                        />
                      ) ) || (
                        <img
                          src={heartIcon_activeFavourite}
                          alt={'un-favourite menu product'}
                          className='mobile-fav-menu-style-unavailable'
                          data-testid='unavailable-fav'
                          onClick={() => addItemToUnFavouriteFunction(tenantId, customerId, product.id)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={`quantityAddtocart ${classesCardButtonDiv(itemCount, isLoggedIn)}`}>
              {!!itemCount && renderQuantityModifier(itemCount, updateItemQuantity, maxItemCountPerLineItem)}
              {isProductAvailable && (
                <div className='cart-btn-container'>
                  <div className={classesCardButton(itemCount, isLoggedIn)}>
                    {itemCount < 1 ? (
                      <button
                        disabled={shouldDisableButton(storeClosedData)}
                        onClick={event =>
                          addToCartFunction(event, product, {
                            productName: catalogueData?.dname,
                            productImage: catalogueData?.imageName,
                            productPrice: getPrice(catalogueData?.availability[0].price),
                          })
                        }
                        className='button activeBtn redButton medium-menu-cart-button '
                        aria-label='Add to Cart'
                        tabindex='0'
                        data-testid='add-to-cart-fav-menu'
                      >
                        {menuCardBtnTextForFavAndRecommendedMenu(storeClosedData).btnText}
                        {displayBucketIcon(storeClosedData.isStoreClosed)}
                      </button>
                    ) : (
                      product.isCustomized && (
                        <span
                          className='edit-selection'
                          data-testid='edit-section-fav-menu'
                          onClick={() => editSelectionsHandlerFavMenu()}
                        >
                          {translateWithI18Next(MENU_PLP_CONSTANT.EDIT_SELECTIONS)}
                        </span>
                      )
                    )}
                  </div>
                </div>
              )}
              {!isProductAvailable && renderItemUnavailableCartBtn()}
            </div>
          </div>
        </div>
        {openCostomizedModal && (
          <CustomizableItemModal
            isFavouriteMenu={true}
            handleClose={() => {
              setOpenCostomizedModal(false);
              setIsEditSelectionFavMenu(false);
            }}
            filteredPreviousData={filteredPreviousData}
            updateItemQuantity={updateItemQuantity}
            tenantData={tenantReducer}
            dname={catalogueData?.dname}
            clickHandler={addToCartFunction}
            cardId={product.id}
            itemCount={itemCount}
            availability={catalogueData?.availability}
            imageName={catalogueData?.imageName}
            itemFoodlineId={itemFoodlineId}
            customizable={product.isCustomized}
            setOpenCostomizedModal={setOpenCostomizedModal}
            openCostomizedModal={openCostomizedModal}
            cartData={cartData}
            product={product}
            foodId={foodId}
            isEditSelection={isEditSelectionFavMenu}
            headerText={
              isEditSelectionFavMenu
                ? translateWithI18Next(MENU_PLP_CONSTANT.EDIT_QUANTITY)
                : translateWithI18Next(MENU_PLP_CONSTANT.SELECT_QUANTITY)
            }
            categoryId={product.id.split('-')[0]}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FavouriteMenuCard;
